import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: calc(100%);
  overflow-x: auto;
  height: 40px;
  width: calc(100vw - 60px);
  transition: all .3s ease;
`
